import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import FAQPage from "@/pages/FAQPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import ContactPage from "@/pages/ContactPage";
import BookAppointmentPage from "@/pages/BookAppointmentPage";
import PricingPage from "@/pages/PricingPage";
import HomeVisitsPage from "@/pages/HomeVisitsPage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAppointments from "@/pages/admin/AdminAppointments";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminBlockedSlots from "@/pages/admin/AdminBlockedSlots";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/treatments" element={<TreatmentsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookAppointmentPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/home-visits" element={<HomeVisitsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/appointments" element={<AdminAppointments />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin/blocked-slots" element={<AdminBlockedSlots />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
